import { ConstraintSpudLimitBase } from './base/constraint-spud-limit-base';

export class ConstraintSpudLimit extends ConstraintSpudLimitBase { }